module.exports = __webpack_public_path__ + "5b27d0741272db6264366baafb736cc1.jpg";